module.exports = __webpack_public_path__ + "static/desktop/img/coupons.0961892e.svg";